"use strict";
exports.__esModule = true;
var _1ds_core_js_1 = require("@microsoft/1ds-core-js");
var Utilities_1 = require("./uwp-wwa/Utilities");
var Utilities_2 = require("./node/Utilities");
var _isReactNative;
var _isReactNativeMobile = false;
var detectReactNative = function () {
    if (_isReactNative === undefined) {
        _isReactNative = _1ds_core_js_1.isReactNative();
        if (_isReactNative) {
            _isReactNativeMobile = require("./react-native-mobile/Utilities").isReactNativeMobile();
        }
    }
    return _isReactNative;
};
exports.isReactNativeMobile = function () {
    detectReactNative();
    return _isReactNativeMobile;
};
var EnvironmentValue;
(function (EnvironmentValue) {
    EnvironmentValue[EnvironmentValue["ReactNativeMobile"] = 0] = "ReactNativeMobile";
    EnvironmentValue[EnvironmentValue["ReactNativeWindows"] = 1] = "ReactNativeWindows";
    EnvironmentValue[EnvironmentValue["WWA"] = 2] = "WWA";
    EnvironmentValue[EnvironmentValue["NodeJs"] = 3] = "NodeJs";
    EnvironmentValue[EnvironmentValue["Browser"] = 4] = "Browser";
})(EnvironmentValue = exports.EnvironmentValue || (exports.EnvironmentValue = {}));
exports.getEnvironment = function () {
    if (detectReactNative()) {
        return _isReactNativeMobile
            ? EnvironmentValue.ReactNativeMobile
            : EnvironmentValue.ReactNativeWindows;
    }
    else if (Utilities_1.isWWA()) {
        return EnvironmentValue.WWA;
    }
    else if (Utilities_2.isNodeEnv()) {
        return EnvironmentValue.NodeJs;
    }
    else {
        return EnvironmentValue.Browser;
    }
};
//# sourceMappingURL=Environment.js.map